import { CouponTypes } from '@/modules/aftersales/types/carInfo'

export const couponType = {
  [CouponTypes.COUPON]: {
    label: '券',
    unit: '张'
  },
  [CouponTypes.GIFT_CARD]: {
    label: '卡',
    unit: '张'
  },
  [CouponTypes.COUPON_PACKAGE]: {
    label: '包',
    unit: '个'
  },
  [CouponTypes.STICKY]: {
    label: '粘',
    unit: '个'
  }
}
